import { render, staticRenderFns } from "./Navbar.vue?vue&type=template&id=fa2b5b68&scoped=true"
import script from "./Navbar.vue?vue&type=script&lang=js"
export * from "./Navbar.vue?vue&type=script&lang=js"
import style0 from "./Navbar.vue?vue&type=style&index=0&id=fa2b5b68&prod&lang=scss"
import style1 from "./Navbar.vue?vue&type=style&index=1&id=fa2b5b68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa2b5b68",
  null
  
)

export default component.exports